export enum ToastMessage {
  INVALID_FILE_MESSAGE = 'Invalid file format',
}
